import { render, staticRenderFns } from "./VisionMissionValues.vue?vue&type=template&id=6ef6d8b5&scoped=true&"
import script from "./VisionMissionValues.vue?vue&type=script&lang=js&"
export * from "./VisionMissionValues.vue?vue&type=script&lang=js&"
import style0 from "./VisionMissionValues.vue?vue&type=style&index=0&id=6ef6d8b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6d8b5",
  null
  
)

export default component.exports